// 筛选
export class EmopTableProHeaderFilterClass {
  /**
   * 是否为多选过滤器
   */
  multiple?: boolean = true;
  /**
   * 筛选的控件
   */
  mode: 'str' | 'num' | 'checkbox' | 'timeSelection' = 'str';
  /**
   * 控件的占位符
   */
  placeholder?: string = '';
  /**
   * 筛选的值
   */
  value?: any = null;
  /**
   * 搜索后的固定值(非双向绑定)
   */
  searchValue?: any = null;
  /**
   * 控件的可见性
   */
  visible?: boolean = false;

  constructor(constructorData: EmopTableProHeaderFilterClass | true) {
    if (typeof constructorData !== 'boolean') {
      for (const key in constructorData) {
        if (constructorData[key] !== undefined) this[key] = constructorData[key];
      }
    }
  }
}